import {
  Button,
  Card,
  DatePicker,
  Modal,
  Popconfirm,
  Radio,
  Space,
  Table,
  Tabs,
  Tag,
  Typography,
} from 'antd';
import locale from 'antd/es/date-picker/locale/vi_VN';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { get, isEmpty, keyBy, merge, values } from 'lodash';
import moment from 'moment';
import 'moment/locale/vi';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Loading from '../../components/Loading';
import BookingApi from '../../functions/api/booking/BookingApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';
import { PAYMENT_METHOD, PAYMENT_STATUS, PAY_AMOUNT } from '../../type/Payment';
import BookingViewButton from './BookingViewButton';
import { columnTitles, TABLE } from './columns';
import ExportFilteringData from './ExportFilteringData';
import LevelBooking from './LevelBooking';
import ListBookingCancel from './ListBookingCancel';
import ShowHashButton from './ShowHashButton';
import ShowImageTransferProof from './ShowImageTransferProof';
const RadioGroup = Radio.Group;

const { RangePicker } = DatePicker;
const { Paragraph } = Typography;

dayjs.extend(isBetween);
dayjs.extend(localizedFormat);

const DEFAULT_DATE_RANGE = [moment().add(-90, 'day'), moment()];
const DEFAULT_VALUE_RADIO_BUTTON = 'book_crta';

const BOOKING_STATUS = {
  PENDING: 0,
  NOTIFIED: 1,
  ACCEPTED: 10,
  DENIED: 20,
};

class ListBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listBooking: [],
      disableMore: false,
      isLoading: true,
      levels: [],
      visibleExportModal: false,
      selectedBooking: null,
      currentTotal: 0,
      currentDataSource: [],
      isCalendarOpen: false,
      bookingTimeDateRange: DEFAULT_DATE_RANGE,
      valueRadioButton: DEFAULT_VALUE_RADIO_BUTTON,
      filteredInfo: TableUtils.getFilterFromUrl(),
    };

    this.filteredBooking = [];
  }

  async componentDidMount() {
    await this.loadBookingsByTime();
    const levels = (await BookingApi.getLevels()) || [];

    this.setState({ levels, isLoading: false });
  }

  activeLevel = (cell, row) => {
    return (
      <LevelBooking
        cell={cell}
        row={row}
        levels={this.state.levels}
        onChange={this.bookingDidChange}
      />
    );
  };

  renderCustomerInfo = (cell, row) => {
    return (
      <React.Fragment>
        <div className="mb-2">
          <strong>{row.cstm_name}</strong>
        </div>
        <div>{row.cstm_phon}</div>
        <div>{row.cstm_emai}</div>
      </React.Fragment>
    );
  };

  renderBookingAddons = (cell, row) => {
    const addons = row.bookingAddons;

    if (addons.length === 0) {
      return null;
    }

    return addons.map((a) => (
      <p key={a.addon.code} className="text-right">
        <span className="small text-muted">
          {a.addon.name}
          {a.meta && (
            <i
              className="fas fa-check text-success ml-2"
              title="Đã upload hồ sơ"
            ></i>
          )}
        </span>
        <br />
        {this.renderActualPriceInsurance(a)}
      </p>
    ));
  };
  renderAcceptStatus = (cell, row) => {
    const statusName = Object.keys(BOOKING_STATUS).find(
      (key) => BOOKING_STATUS[key] === row.accept_status
    );

    return <span>{statusName}</span>;
  };

  renderActualPriceInsurance = (addon) => {
    if (addon.actual_price === null || addon.actual_price === addon.price) {
      return MyUtil.currencyFormat(addon.price);
    }

    return (
      <>
        <strike className="text-muted small">
          {MyUtil.currencyFormat(addon.price)}
        </strike>
        <span>{MyUtil.currencyFormat(addon.actual_price)}</span>
      </>
    );
  };

  getPaymentMethodName(methodId) {
    switch (methodId) {
      case PAYMENT_METHOD.CASH:
        return 'Tiền mặt';
      case PAYMENT_METHOD.ONLINE:
        return 'Online';
      case PAYMENT_METHOD.MOMO:
        return 'Momo';
      case PAYMENT_METHOD.TRANSFER:
        return 'Chuyển khoản';
      default:
        return 'Không xác định';
    }
  }

  renderPayment = (payment_info) => {
    if (isEmpty(payment_info) || isEmpty(payment_info.paymentMethodInfo)) {
      return <span>Không có thông tin</span>;
    }

    const { paymentMethod, amountType } = payment_info.paymentMethodInfo;
    const { paymentStatus, paymentAmount, paymentInfo, transferProof } =
      payment_info.paymentDetail;
    const paymentInfoVNP = paymentInfo ? JSON.parse(paymentInfo) : {};

    return (
      <>
        {paymentMethod === PAYMENT_METHOD.ONLINE && (
          <>
            {paymentStatus === PAYMENT_STATUS.SUCCESS ? (
              <>
                <Tag color="success">Đã thanh toán</Tag>
                {!isEmpty(paymentInfoVNP) && paymentInfoVNP.vnpTxnRef && (
                  <Tag color="info">(Mã G/D: {paymentInfoVNP.vnpTxnRef})</Tag>
                )}
              </>
            ) : (
              <Tag color="warning"> Chưa thanh toán</Tag>
            )}
            <div>{MyUtil.currencyFormat(paymentAmount)}</div>
          </>
        )}

        <div>
          ({this.getPaymentMethodName(paymentMethod)}, &nbsp;
          {Number(amountType) === PAY_AMOUNT.DEPOSIT ? 'Đặt cọc' : 'Toàn bộ'})
          {'Chuyển khoản' === this.getPaymentMethodName(paymentMethod) &&
            undefined !== transferProof && (
              <>
                <br />
                <ShowImageTransferProof images={transferProof} />
              </>
            )}
        </div>
      </>
    );
  };

  handleInsertButtonClick = () => {
    this.props.history.push('/booking/add-booking');
  };

  bookingDidChange = (updatedBooking) => {
    const bookings = [...this.state.listBooking]; // not mutate state
    const indexToReplace = bookings.findIndex(
      (b) => b.book_id === updatedBooking.book_id
    );

    bookings.splice(indexToReplace, 1, updatedBooking);

    this.setState({ listBooking: bookings, currentDataSource: bookings });
  };

  onChangeRadioButton = async (e) => {
    this.setState(
      {
        valueRadioButton: e.target.value,
      },
      this.loadBookingsByTime
    );
  };

  getColumnDropDownFilterSupporter(dataIndex) {
    const { listBooking } = this.state;
    const filters = listBooking
      .map((b) => get(b, dataIndex))
      .filter((option, index, all) => all.indexOf(option) === index)
      .filter((o) => !isEmpty(o))
      .map((o) => ({
        text: o,
        value: o,
      }));

    filters.push({
      text: '(trống)',
      value: null,
    });

    return {
      filters,
      onFilter: (value, record) => get(record, dataIndex) === value,
    };
  }

  getAcceptanceStatusFilter() {
    const filters = Object.entries(BOOKING_STATUS).map(([key, value]) => ({
      text: key,
      value,
    }));

    filters.push({
      text: '(trống)',
      value: null,
    });

    return {
      filters,
      onFilter: (value, record) => {
        const [lastAcceptanceStatus] = record.bookingAcceptance.slice(-1);
        if (value === null && lastAcceptanceStatus === undefined) {
          return true;
        }

        return lastAcceptanceStatus?.status === value;
      },
    };
  }

  getLevelDropdownFilter = () => {
    const { levels } = this.state;
    return {
      filters: levels
        .map((l) => ({ text: l.book_stt_name, value: l.book_stt_id }))
        .sort((a, b) => a.text.localeCompare(b.text)),
      onFilter: (value, record) => get(record, 'book_stt_id') === value,
    };
  };

  getColumnDateFilter = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <DatePicker
          autoFocus
          format="ll"
          onChange={(selected) => {
            setSelectedKeys([selected]);
            confirm();
          }}
        />
      ),
      onFilter: (value, record) => {
        if (!value) {
          return true;
        }

        const recordDateValue = dayjs(record[dataIndex]);
        if (!recordDateValue.isValid()) {
          return false;
        }
        return recordDateValue.isSame(value, 'day');
      },
    };
  };

  getColumnDateRangeFilter = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <RangePicker
          onChange={(selected) => {
            setSelectedKeys([selected]);
            confirm();
          }}
          autoFocus
          format="ll"
        />
      ),
      onFilter: (value, record) => {
        if (!value) {
          return true;
        }

        let [start, end] = value;

        if (!start || !end) {
          return true;
        }

        const recordDateValue = dayjs(record[dataIndex]);
        if (!recordDateValue.isValid()) {
          return false;
        }
        return recordDateValue.isBetween(start, end, 'day', '[]');
      },
    };
  };

  getCurrencyColProps() {
    return {
      align: 'right',
    };
  }

  handleDelete = async (key) => {
    await BookingApi.delete(key);
    await this.loadBookingsByTime();
  };

  renderBookingTotal = (bookingTotal, record) => {
    if (record.book_price_total_actual) {
      return (
        <>
          <i className="fa fa-check-circle text-success" />
          {MyUtil.currencyFormat(record.book_price_total_actual)}
        </>
      );
    }

    return MyUtil.currencyFormat(bookingTotal);
  };

  tableSourceDidChange = (
    pagination,
    filters,
    sorter,
    { currentDataSource }
  ) => {
    TableUtils.pushFilterToUrl(filters);
    this.setState({
      currentTotal: currentDataSource.length,
      currentDataSource: currentDataSource,
      filteredInfo: filters,
    });
  };

  formatDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined) {
      return null;
    }
    return (
      <>
        {dayjs(dateValue).format('HH:mm')}
        <br />
        {dayjs(dateValue).format('D/M/YYYY')}
      </>
    );
  };

  loadBookingsByTime = async () => {
    const {
      bookingTimeDateRange: dates,
      isCalendarOpen,
      valueRadioButton,
    } = this.state;

    if (isCalendarOpen) {
      return;
    }

    this.setState({ isLoading: true });

    const start = dates[0] ?? dayjs().add(-1, 'month');
    const end = dates[1] ?? dayjs();

    const sdate = start.startOf('day').format();
    const edate = end.endOf('day').format();

    const listBooking = await BookingApi.getAllBetweenTime(
      sdate,
      edate,
      valueRadioButton
    );

    this.setState({
      listBooking,
      currentTotal: listBooking.length,
      isLoading: false,
      currentDataSource: listBooking,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { isCalendarOpen } = this.state;
    if (prevState.isCalendarOpen && !isCalendarOpen) {
      this.loadBookingsByTime();
    }
  }

  getColumnConfig = (filteredInfo) => {
    const canDelete = MyUtil.hasPermission('/booking', 'delete');
    const { listBooking } = this.state;

    const columnConfigs = [
      {
        dataIndex: 'book_code',
        key: 'book_code',
        fixed: 'left',
        filteredValue: filteredInfo.book_code || null,
        ...TableUtils.getColumnSearchProps('book_code'),
      },
      {
        dataIndex: 'cstm_name',
        key: 'cstm_name',
        render: this.renderCustomerInfo,
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('cstm_name'),
        onFilter(value, record) {
          if (!record['cstm_name'] && !record['cstm_phon']) {
            return false;
          }

          return (
            record['cstm_name']
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()) ||
            record['cstm_phon']
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          );
        },
        filteredValue: filteredInfo.cstm_name || null,
      },
      {
        dataIndex: 'book_crta',
        key: 'book_crta',
        render: this.formatDate,
        align: 'right',
        ...this.getColumnDateFilter('book_crta'),
        filteredValue: filteredInfo.book_crta || null,
        sorter: (a, b) => dayjs(a.book_crta).diff(dayjs(b.book_crta), 's'),
      },
      {
        dataIndex: 'book_rental_date_actual',
        render: this.formatDate,
        className: 'text-primary',
        align: 'right',
        ...this.getColumnDateRangeFilter('book_rental_date_actual'),
        filteredValue: filteredInfo.book_rental_date_actual || null,
        sorter: (a, b) =>
          dayjs(a.book_rental_date_actual).diff(
            dayjs(b.book_rental_date_actual),
            's'
          ),
      },
      {
        dataIndex: 'book_return_date_actual',
        render: this.formatDate,
        align: 'right',
        ...this.getColumnDateFilter('book_return_date_actual'),
        filteredValue: filteredInfo.book_return_date_actual || null,
      },
      {
        dataIndex: ['book_src_key'],
        key: 'book_src_key',
        filteredValue: filteredInfo.book_src_key || null,
        ...TableUtils.getColumnDropDownFilter(listBooking, [['book_src_key']]),
      },
      {
        dataIndex: ['bookingAddons', 'name'],
        key: 'bookingAddons_name',
        render: this.renderBookingAddons,
        filteredValue: filteredInfo.bookingAddons_name || null,
      },
      {
        dataIndex: ['accept_status'],
        key: 'accept_status',
        render: this.renderAcceptStatus,
        ...this.getAcceptanceStatusFilter(),
        filteredValue: filteredInfo.accept_status || null,
      },
      {
        dataIndex: 'support_user_acc_full_name',
        key: 'support_user_acc_full_name',
        ...this.getColumnDropDownFilterSupporter('support_user_acc_full_name'),
        filteredValue: filteredInfo.support_user_acc_full_name || null,
      },
      {
        dataIndex: 'supply_side_operator_name',
        key: 'supply_side_operator_name',
        ...this.getColumnDropDownFilterSupporter('supply_side_operator_name'),
        filteredValue: filteredInfo.supply_side_operator_name || null,
      },
      {
        dataIndex: 'vhc_type_name',
        key: 'vhc_type_name',
        ...TableUtils.getColumnDropDownFilter(listBooking, 'vhc_type_name'),
        filteredValue: filteredInfo.vhc_type_name || null,
      },

      {
        dataIndex: 'part_name',
        render: (cell, record) => {
          if (record.part_id_actual === 0) {
            return 'Ngoài hệ thống';
          }

          const output = cell;

          if (isEmpty(record.part_name_actual)) {
            return output;
          }

          return (
            <>
              {output}
              <div>&darr;</div>
              {record.part_name_actual}
            </>
          );
        },
        ...TableUtils.getColumnDropDownFilter(listBooking, [
          'part_name',
          'part_name_actual',
        ]),
        filteredValue: filteredInfo.part_name || null,
      },
      {
        dataIndex: 'book_prie_tota',
        key: 'book_prie_tota',
        render: this.renderBookingTotal,
        align: 'right',
        filteredValue: filteredInfo.book_prie_tota || null,
      },
      {
        dataIndex: 'paid_amount',
        key: 'paid_amount',
        align: 'right',
        render: MyUtil.currencyFormat,
      },
      {
        dataIndex: 'book_resn_name',
        key: 'book_resn_name',
        width: 150,
        ...TableUtils.getColumnDropDownFilter(listBooking, 'book_resn_name'),
        filteredValue: filteredInfo.book_resn_name || null,
      },
      {
        dataIndex: 'payment_info',
        key: 'payment_info',
        render: this.renderPayment,
      },
      {
        key: 'level',
        dataIndex: 'book_stt_id',
        render: this.activeLevel,
        ...this.getLevelDropdownFilter(),
        filteredValue: filteredInfo.level || null,
      },
      {
        title: null,
        key: 'delete',
        fixed: 'right',
        render: (text, record) => {
          return (
            <Space>
              <ShowHashButton record={record} />
              <Button
                onClick={() => {
                  this.setState({ selectedBooking: record });
                }}
                size="small"
                className="pull-right"
              >
                <i className="fas fa-clipboard-list"></i>
              </Button>
              <BookingViewButton record={record} />
              <Button
                size="small"
                onClick={() =>
                  this.props.history.push(
                    `/booking/edit-booking/${record.book_code}`
                  )
                }
              >
                <i className="fas fa-edit"></i>
              </Button>
              {canDelete && (
                <Popconfirm
                  title="Bạn chắc chắn muốn xóa?"
                  onConfirm={() => this.handleDelete(record.book_id)}
                >
                  <Button size="small" danger>
                    <i className="fas fa-trash"></i>
                  </Button>
                </Popconfirm>
              )}
            </Space>
          );
        },
      },
    ];

    const titles = columnTitles.filter((t) => t.hideOn !== TABLE.BACKEND);

    // merge titles with configs
    const mergeKey = 'dataIndex';
    return values(
      merge(keyBy(titles, mergeKey), keyBy(columnConfigs, mergeKey))
    );
  };

  render() {
    const {
      listBooking,
      selectedBooking,
      currentTotal,
      isLoading,
      currentDataSource,
      valueRadioButton,
      filteredInfo,
    } = this.state;

    const columns = this.getColumnConfig(filteredInfo);

    return (
      <>
        <Tabs defaultActiveKey="1" centered>
          <Tabs.TabPane tab="Tất cả" key="1">
            <Card className="mb-2" size="small">
              <Space>
                {MyUtil.hasPermission('/booking', 'add') && (
                  <Button onClick={this.handleInsertButtonClick} type="primary">
                    Thêm
                  </Button>
                )}
                <ExportFilteringData currentDataSource={currentDataSource} />
              </Space>
              <div className="float-right">
                <span className="mr-3">Lọc booking theo</span>
                <RadioGroup
                  onChange={this.onChangeRadioButton}
                  value={valueRadioButton}
                >
                  <Radio value={'book_crta'}>Ngày tạo</Radio>
                  <Radio value={'book_rent_date'}>Ngày nhận</Radio>
                </RadioGroup>
                <RangePicker
                  ranges={{
                    'Hôm nay': [moment(), moment()],
                    '7 ngày trước': [
                      moment().subtract(7, 'days').startOf('day'),
                      moment().startOf('day'),
                    ],
                    '7 ngày tới': [
                      moment().startOf('day'),
                      moment().add(7, 'days').startOf('day'),
                    ],
                  }}
                  allowClear={false}
                  locale={locale}
                  format="DD/MM/YYYY"
                  defaultValue={DEFAULT_DATE_RANGE}
                  onOpenChange={(isCalendarOpen) => {
                    this.setState({ isCalendarOpen });
                  }}
                  onCalendarChange={(dates) => {
                    this.setState({ bookingTimeDateRange: dates });
                  }}
                />
              </div>
            </Card>
            <Modal
              title="Ghi chú"
              visible={!!selectedBooking}
              onCancel={() => this.setState({ selectedBooking: null })}
              footer={
                <Button
                  type="primary"
                  onClick={() => this.setState({ selectedBooking: null })}
                >
                  OK
                </Button>
              }
            >
              {selectedBooking && (
                <>
                  <Paragraph>
                    <strong>Ghi chú của khách hàng</strong>
                    <pre>{selectedBooking.book_note}</pre>
                  </Paragraph>
                  <Paragraph className="mt-4">
                    <strong>Lịch sử gọi</strong>
                    <pre>{selectedBooking.his_call}</pre>
                  </Paragraph>
                </>
              )}
            </Modal>
            {isLoading ? (
              <Loading />
            ) : (
              <Table
                rowKey="book_id"
                size="small"
                columns={columns}
                dataSource={listBooking}
                scroll={{ x: 'max-content' }}
                onChange={this.tableSourceDidChange}
                title={() => `Tổng số: ${currentTotal}`}
                rowClassName={(record, index) =>
                  record.part_id === null &&
                  record.part_id_actual === null &&
                  'text-danger'
                }
              />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane tab="Đã huỷ" key="2">
            <ListBookingCancel />
          </Tabs.TabPane>
        </Tabs>
      </>
    );
  }
}

export default withRouter(ListBooking);
